<template>
    <PopupModal :show="showDialog" type="primary">
        <div class="authenticator-container">
            <div class="logo-container q-my-lg">
                <img class="logo" alt="logo" :src="logo" />
            </div>
            <div class="title q-my-lg">{{ $t("shared.Login") }}</div>
            <div class="button-container">
                <div v-for="authenticator in sortedAuthenticator" :key="JSON.stringify(authenticator)">
                    <QitButton
                        class="authenticator-button border"
                        color="white"
                        :label="authenticator.displayName"
                        @click="
                            () => {
                                emit('onAuthenticatorSelected', authenticator);
                            }
                        "
                    />
                </div>
            </div>
        </div>
    </PopupModal>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import PopupModal from "@/shared/components/popup/popup-modal.vue";
import { Authenticator } from "@/shared/services/graphql/generated/public-graph-types";
import { publicClient } from "@/shared/services/apollo-clients/public-client";
import { LOGO_QUERY } from "../graphql/logo.query";
import QitButton from "@/shared/components/buttons/qit-button.vue";
import QUANOS_LOGO from "@/shared/assets/images/quanos.svg?url";
import { watchImmediate } from "@vueuse/core";

const loading = ref(true);
const logo = ref<string>("");

const loadLogo = async () => {
    const result = await publicClient.query({ query: LOGO_QUERY });
    const customLogo = result.data.theme.logo;

    logo.value = customLogo ? customLogo.url : QUANOS_LOGO;
    loading.value = false;
};
const props = defineProps<{
    authenticators: Authenticator[];
    show: boolean;
}>();

const emit = defineEmits<{
    (e: "onAuthenticatorSelected", data: Authenticator): void;
}>();

watchImmediate(
    () => props.show,
    () => {
        if (props.show) loadLogo();
    }
);

const showDialog = computed(() => {
    return props.authenticators.length > 0 && props.show && !loading.value;
});

const sortedAuthenticator = computed(() => {
    if (props.authenticators.some((x: Authenticator) => x.sortIndex > 0))
        return [...props.authenticators].sort((a, b) => {
            return b.sortIndex - a.sortIndex;
        });

    return props.authenticators;
});
</script>

<style lang="scss" scoped>
.title {
    font-size: 20px;
    font-weight: $bold;
}
.authenticator-container {
    display: flex;
    justify-content: center;
    text-align: center;
    flex-direction: column;

    h2 {
        margin-bottom: 1rem;
        margin-top: 3rem;
    }
}
.logo-container {
    display: flex;
    justify-content: center;
}
.logo {
    max-width: 250px;
    max-height: 250px;
}
.authenticator-button {
    text-align: left;
    margin: $spacing-m;
    min-width: 300px;
}
</style>
